import { registerShapeFactory } from '../base';
var SchemaShapeFactory = registerShapeFactory('schema', {
    defaultShapeType: '', // 'schema' is for some custom shapes, so will not specify defaultShapeType
});
export default SchemaShapeFactory;
//# sourceMappingURL=index.js.map